<script setup lang="ts">

import LingoGiveawayGameCounter from '@/partners/lingo/lingo-giveaway/components/LingoGiveawayGameCounter.vue'
import { ref, watch } from 'vue'
import { useScreenSize } from '@/composables/helpers/screen-size'

defineProps<{
  image: string,
  count: number
  isGold?: boolean
}>()

const aspectRatio = 520 / 352
const characterImage = ref<HTMLElement | null>()
const characterImageHeight = ref(0)
const { width } = useScreenSize()

function calculateImageHeight() {
  if (!characterImage.value) return
  characterImageHeight.value = characterImage.value.offsetWidth * aspectRatio
}

watch(characterImage, characterImage => {
  if (!characterImage) return
  calculateImageHeight()
}, { immediate: true })

watch(width, () => calculateImageHeight())
</script>

<template>
  <div
    class="w-full relative flex items-end"
    :class="{'invisible': !characterImageHeight}"
    :style="{'minHeight': characterImageHeight + 'px'}"
  >
    <img
      class="absolute left-[2px] bottom-4 w-[calc(100%-4px)] z-[1] object-top object-cover"
      :src="image"
      ref="characterImage"
      :style="{height: (characterImageHeight * 0.75) + 'px'}"
    >
    <img
      v-if="isGold"
      class="egg-image"
      src="@/partners/lingo/lingo-giveaway/assets/images/egg-bottom-gold.png"
    >
    <img
      v-else
      class="egg-image"
      src="@/partners/lingo/lingo-giveaway/assets/images/egg-bottom-purple.png"
    >
    <LingoGiveawayGameCounter
      :count="count"
      :is-gold="isGold"
      class="absolute left-1/2 -translate-x-1/2 -bottom-1.5 z-[3]"
      :bg-class="isGold ? undefined : 'bg-counter-purple'"
    />
  </div>
</template>

<style lang="scss">
.egg-image {
  @apply w-full h-auto object-cover z-[2];
}
</style>